import React from 'react';
import {
  makeStyles,
  Typography,
  Button,
} from '@material-ui/core';

import User from './components/User';
import Canvas from './components/Canvas';

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '40px 30px 20px',
    '& h1': {
      textAlign: 'center',
      marginBottom: '20px',
    },
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div:first-child': {
      width: '230px',
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    '& button': {
      margin: '0 5px',
    },
  },
}));

const BrandMultiEditor = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <Typography variant="h5" component="h1" gutterBottom>
        Brand Editor
      </Typography>
      <center>
        <i>Albert is editing...</i>
      </center>
      <br />
      <div className={classes.content}>
        <div>
          <Typography variant="subtitle1" component="h2" gutterBottom>
            Users:
          </Typography>
          <User name="Albert Miclat" role="Admin" selected />
          <User name="John Doe" role="Brand Owner" />
        </div>
        <div>
          <Canvas />
        </div>
      </div>
      <br />
      <div className={classes.actions}>
        <Button variant="outlined" color="primary" size="small">
          Leave
        </Button>
        <Button variant="contained" color="primary" size="small">
          Save & Leave
        </Button>
      </div>
    </div>
  );
};

export default BrandMultiEditor;
